export class MobileIFrameExportPdfAlertModalData {
    url: string;

    constructor(url: string) {
        this.url = url;
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/mobile.iframe.export.pdf.alert.modal/mobile.iframe.export.pdf.alert.modal.provider.ts